<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="id"
                         label="id"></el-table-column>
        <el-table-column prop="display_name"
                         label="显示名称"></el-table-column>
        <el-table-column prop="admin_name"
                         label="上传人"></el-table-column>
        <el-table-column prop="status"
                         label="状态">
          <template slot-scope="scope">
            <span v-for="item in options.status"
                  v-if="item.value === scope.row.status">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="success_count"
                         label="成功数"></el-table-column>
        <el-table-column prop="error_count"
                         label="失败数"></el-table-column>
        <el-table-column prop="task_type"
                         label="类型">
          <template slot-scope="scope">
            <span v-for="item in options.task_type"
                  v-if="item.value === scope.row.task_type">{{item.label}}</span>
          </template>

        </el-table-column>
        <el-table-column prop="created_at"
                         label="上传时间"></el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <el-button type="text"
                       size="mini"
                       @click="onDownSourceFile(scope.row.id)">下载
            </el-button>
            <span v-if="(scope.row.status === 3 && scope.row.error_count > 0) || scope.row.status === -2">
              <el-button type="text"
                         size="mini"
                         @click="onDownErrorFile(scope.row.id)">下载错误行</el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

  </div>
</template>

<script>
import table from '@core/mixins/table'

export default {
  mixins: [table],
  data () {
    return {
      multipleSelection: [],
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
      search: {
        collection_type: 6,
        number: this.$route.params.number || '',
      },
      // 搜索字段申明
      searchFieldType: {
        collection_type: Number,
      },
      options: {
        task_type: [
          {value: 1, label: '批量添加'},
          {value: 2, label: '批量删除'},
          {value: 3, label: '批量修改'},
          {value: 4, label: '批量上传标签库'},
          {value: 5, label: '批量下载'},
        ],
        status: [
          {value: 1, label: '等待开始'},
          {value: 2, label: '进行中'},
          {value: 3, label: '处理完成'},
          {value: -1, label: '已取消'},
          {value: -2, label: '失败'},
          {value: -3, label: '已删除'},
        ],

      },
    }
  },

  computed: Vuex.mapState({}),

  methods: {
    ...Vuex.mapActions([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.common('getTekeInfiniteTagUpload', params)
    },
    onDownSourceFile (id) {
      return request.alert('downTekeSourceFile', id)
    },
    onDownErrorFile (id) {
      return request.alert('downTekeErrorFile', id)
    },

  },
}
</script>



// WEBPACK FOOTER //
// src/views/teke-tag/pages/TekeInfiniteTagUploadTable.vue